module.exports = __webpack_public_path__ + "media/site_templates/www.localhandyman.net.au/images/splash-4f2a4240f475f870f108fc125ce61d85.jpeg";